import { cn } from '@/lib/utils'
import { isUrlEmbeddableInIframe } from '@/utils/url-embeddable'
import { ExternalLink } from 'lucide-react'

type PolicySourceUrlViewerProps = {
  url: string
  className?: string
  minHeight?: string
}

const PolicySourceUrlLink = ({ url, className }: PolicySourceUrlViewerProps) => (
  <div className={cn('mt-4 border rounded-md p-4 space-y-2', className)}>
    <p className='text-sm text-muted-foreground'>
      This source cannot be previewed on this page. Please open the link below in your browser:
    </p>
    <a
      href={url}
      target='_blank'
      rel='noopener noreferrer'
      className='inline-flex items-start gap-2 text-sm font-medium text-blue-600 hover:underline break-all'
    >
      <ExternalLink className='h-4 w-4 shrink-0 mt-0.5' />
      <span>{url}</span>
    </a>
  </div>
)

export const PolicySourceUrlViewer = ({ url, className, minHeight = '600px' }: PolicySourceUrlViewerProps) => {
  if (!url) return null
  if (!isUrlEmbeddableInIframe(url)) return <PolicySourceUrlLink url={url} className={className} />

  return (
    <div className={cn('mt-4 border rounded-md overflow-hidden', className)}>
      <iframe
        src={url}
        title='Policy Source'
        style={{ width: '100%', minHeight: minHeight, border: 'none' }}
        allowFullScreen
      />
    </div>
  )
}
